'use client';

import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

const Input = forwardRef(function Input(
  {
    label,
    error,
    required,
    className,
    type = 'text',
    ...props
  },
  ref
) {
  return (
    <div className="space-y-2">
      {label && (
        <label className="block text-sm font-medium text-slate-700">
          {label}
          {required && <span className="text-blue-500 ml-0.5">*</span>}
        </label>
      )}
      <input
        ref={ref}
        type={type}
        className={cn(
          'w-full px-4 py-3.5 bg-white border rounded-xl text-slate-800',
          'placeholder:text-slate-400',
          'focus:outline-none focus:ring-2 focus:border-blue-500',
          'transition-all duration-200',
          error
            ? 'border-red-500 bg-red-50 focus:ring-red-500/30'
            : 'border-slate-200 focus:ring-blue-500/30',
          className
        )}
        {...props}
      />
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
    </div>
  );
});

export default Input;
